import React from "react";
import { Card, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { useSideTabsPosition } from "~/hooks/useIsMobile";
import TraineeDevices from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeSettings/TraineeDevices";
import TraineeNotifications from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeSettings/TraineeNotifications";
import { TraineeLanguage } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeSettings/TraineeLanguage";
import TraineeWorkoutSettings from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeSettings/TraineeWorkoutSettings";
import { useTraineeId, useTraineeSearchParams } from "~/modules/Trainee/TraineeProfile/scope";

const TraineeSettings = () => {
  const sideTabsPosition = useSideTabsPosition();
  const { t } = useTranslation(["trainees", "common", "workouts"]);
  const [search] = useTraineeSearchParams();
  const traineeId = useTraineeId();

  return (
    <Card bordered={false} className="!shadow-none">
      <div className="mb-4">
        <TraineeLanguage traineeId={traineeId} />
      </div>
      <Tabs tabPosition={sideTabsPosition} defaultActiveKey={search.get("settingsTab") || "notifications"}>
        <Tabs.TabPane tab={t("features.notifications")} key="notifications">
          <TraineeNotifications />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t("hint.settingsTitle", { ns: "workouts" })} key="workouts">
          <TraineeWorkoutSettings />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t("settings.devices")} key="devices">
          <TraineeDevices />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  );
};

export default TraineeSettings;
